module.exports = __webpack_public_path__ + "img/intelligence-banner.png";